<template>
  <div id="score-met" class="row">
    <div class="col-sm-12 col-md-11 col-lg-11">
      <!-- intro -->
      <h3 class="font-weight-100">¿Cómo calificamos los proyectos semilla?</h3>
      <p class="body-font1">
        El compromiso con nuestra comunidad de inversionistas siempre ha sido el mismo: 
        ofrecer atractivos proyectos de inversión, con alto impacto ambiental y social, <span class="bold">a bajo riesgo.</span>
        <br><br>
        Tomando este principio en consideración, hemos desarrollado un modelo de riesgo 
        crediticio, el cual está presente durante todo el proceso de evaluación de nuestros 
        solicitantes, desde el inicio de su solicitud hasta la aceptación del crédito.

      </p>

      <!-- solicitud y documentación -->
      <h3 class="font-weight-100">El proceso de evaluación, selección y calificación.</h3>
      <h4 class="font-weight-100">Solicitud y documentación.</h4>
      <p class="body-font1">
        RedGirasol tiene distintos medios para originar solicitudes de crédito. A través de 
        promotores de crédito (integradores solares verificados o brokers), alianzas comerciales o 
        nuestro equipo comercial, que buscan y atienden empresas o personas con proyectos 
        alineados a nuestra política de alto impacto ambiental y social.
        <br>
        <br>
        Independientemente de cual sea el medio de originación, todas las solicitudes de crédito pasan por un proceso
        detallado de evaluación, selección y calificación.
        <br>
        <br>
        La integración de una solicitud de crédito es realizada desde nuestra plataforma por el propio solicitante.
        En ésta requerimos información y documentación como nombre, domicilio, número telefónico,
        correo electrónico, CURP, identificación oficial, estados de cuenta bancarios, entre otros, a todos nuestros
        solicitantes (para personas morales se exige información y documentación específica), además de los datos más
        relevantes sobre el destino de los recursos. Una vez que la solicitud está completa, RedGirasol ejecuta el modelo de riesgos.
      </p>

      
      <!-- Verificación de identidad -->
      <h4 class="font-weight-100">Verificación de identidad.</h4>
      <p class="body-font1">
        Para solicitar un crédito, necesitamos verificar quién es el solicitante. En este proceso utilizamos un software de reconocimiento de identidad autorizado por la CNBV.
        <br><br>
        Los solicitantes pasan por una comprobación biométrica y de documentos en donde tendrán que grabar un breve vídeo haciendo dos círculos invisibles con su nariz y subir una identificación oficial.
        <br><br>
        Posteriormente, el software se encargará de corroborar que sus datos coincidan con su identidad, además de confirmar la geolocalización del usuario al momento de realizar el proceso. En caso de que no se detecten problemas, el perfil del solicitante será verificado y la evaluación de la solicitud podrá continuar.
      </p>

      <!-- modelo de riesgos -->
      <h4 class="font-weight-100">El modelo de riesgos.</h4>
      <p class="body-font1">
        Este modelo, con el que determinaremos el grado de riesgo de los solicitantes, se compone de características dinámicas, divididas en cuatro categorías y en distintos indicadores que se cuantifican para calificar al proyecto y al solicitante en una escala global de 0 a 100 puntos.
      </p>

      <!-- criterios de selección -->
      <div>
        <h4 class="font-weight-100">Criterios de evaluación.</h4>
        <!-- subtitulo -->
        <h6 class="primary bold">Reputación y comportamiento</h6>
        <p class="body-font1">
          Con la información que ingresa el solicitante obtenemos resultados acerca de su <span class="bold">historial crediticio</span> y de su <span class="bold">situación jurídica</span>.
          <br>
          <br>
          Esta parte del modelo hace su propia interpretación del historial crediticio y situación jurídica del solicitante. Con los resultados obtenidos, el modelo determinará si el historial crediticio y situación jurídica del solicitante es apto para el otorgamiento de un crédito
        </p>
        <!-- subtitulo -->
        <!-- <h6 class="primary bold">Proyecto</h6>
        <p class="body-font1">
          Después de la pre-aprobación comienza el proceso de aprobación, donde se aplica la 
          categoría de <span class="bold">proyecto</span> para el caso de las solicitudes de Crédito Solar. En esta categoría, 
          que considera tanto la tecnología y su valor, así como la ubicación, nos ayuda a determinar 
          la viabilidad y factibilidad del proyecto.
          <br>
          <br>
          La <span class="bold">ubicación del proyecto</span> se considera en el riesgo del proyecto debido a distintos factores.
          <br>
          <br>
          Uno de ellos es por que, en el caso de sistemas fotovoltaicos, la interconexión del sistema solar depende al 100% de la Comisión Federal de Electricidad. La infraestructura de la CFE es muy variable, cada estado tiene diferente administración  y los tiempos de interconexión para este tipo de proyectos son distintos. 
          <br>
          <br>
          Por otro lado, también se toma en cuenta la ubicación por el nivel de inseguridad que ésta pueda llegar a tener, por la facilidad de que el área legal pueda ejecutar una cobranza extrajudicial y recuperar el sistema en garantía y por la cercanía del instalador al mismo proyecto para futura atención.
          <br>
          <br>
          El instalador entrega la información acerca de la tecnología del proyecto y el cliente la información de la ubicación del proyecto. En base a eso, se determina el análisis de lo mencionado anteriormente a través de información histórica de <span class="bold">RedGirasol</span> o de proveedores de información.
        </p> -->
        <!-- subtitulo -->
        <h6 class="primary bold">Garantía</h6>
        <p class="body-font1">
          Esta categoría mide la calidad de la garantía establecida en el crédito. Los productos crediticios cuentan con garantías preestablecidas con opción a incluir adicionales. Todos los créditos cuentan con obligado solidario y pagaré como parte de las garantías.
        </p>
        <!-- TABLA DE GARANTÍAS -->
        <table class="table mb--50">
          <thead>
            <tr class="text-align-center">
              <th scope="col">Producto</th>
              <th scope="col">Obligado solidario</th>
              <th scope="col">Pagaré</th>
              <th scope="col">Garantía prendaria</th>
              <th scope="col">Otra garantía</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th scope="row">Crédito Solar RedGirasol</th>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="text-align-center">Paneles instalados</td>
              <td class="text-align-center">Opcional</td>
            </tr>
            <tr>
              <th scope="row">Crédito PYME RedGirasol</th>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="text-align-center">Cuentas por cobrar</td>
              <td class="text-align-center">Opcional</td>
            </tr>
            <tr>
              <th scope="row">Crédito Automotriz RedGirasol</th>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="text-align-center">Vehículo financiado</td>
              <td class="text-align-center">Opcional</td>
            </tr>
            <tr>
              <th scope="row">Crédito Personal RedGirasol</th>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="primary text-align-center">&#x2714;</td>
              <td class="text-align-center">No obligatoria</td>
              <td class="text-align-center">Opcional</td>
            </tr>
          </tbody>
        </table>
        <p class="body-font1">
          Esta categoría permite comparar la calidad de las diferentes garantías en los créditos. Es posible que un cliente deje una garantía adicional a la requerida por el producto crediticio.
          Ejemplo, un Crédito Personal con una garantía prendaria. El crédito personal no tiene requisito de garantía, pero es posible ingresar cualquier garantía en caso que el cliente lo desee o RedGirasol lo solicite.
        </p>
        
        <!-- subtitulo -->
        <h6 class="primary bold">Destino de los recursos</h6>
        <p class="body-font1">
          Evalúa el control sobre el destino de los recursos y la seguridad de que éste traerá un beneficio al cliente para solventar el mismo crédito.
        </p>

        <!-- subtitulo -->
        <h6 class="primary bold">Capacidad de pago</h6>
        <p class="body-font1">
          Esta categoría mide el tipo de ingresos que el cliente percibe y la calidad de éstos en relación a su estabilidad y al monto solicitado. Esta información se utiliza para determinar si el flujo de ingresos o gastos es suficientemente alto como para tolerar una mensualidad del crédito en solicitud.
          <br>
          <br>
          Existen distintas maneras de comprobar su capacidad de pago, puede ser a través de recibos de nómina, estados de cuenta o inclusive a través de los gastos operativos de su negocio. Es importante mencionar que el tipo de comprobante que utilice, influirá en el riesgo determinado.
          <br>
          <br>
          El <span class="bold">modelo de riesgos</span> también tomará en cuenta el canal de cobranza que el solicitante decida tomar para realizar sus pagos. 
          <br>
          <span class="bold">RedGirasol</span> tiene dos canales de cobranza. El primero es a través de transferencias bancarias, donde el cliente hace una transferencia electrónica para cada uno de sus pagos.
          <br>
          <br>
          La segunda opción de cobranza es la <span class="bold">domiciliación</span>, obligatoria para personas morales. El solicitante persona física puede decidir no domiciliar los pagos y hacerse responsable de ejecutar el pago cada mes. Esta decisión por parte del cliente afecta su calificación en el riesgo del proyecto ya que minimiza los canales de cobranza.
        </p>
        <!-- subtitulo -->
        <h6 class="primary bold">Perfil</h6>
        <p >
          Esta última categoría cuantifica las <span class="bold">características demográficas del solicitante</span>. Esta información, que es proporcionada por el cliente, intenta medir la madurez y responsabilidad de dicha persona para determinar su nivel personal de compromiso de pago.
        </p>
      </div>

      <!-- calificaci[on] -->
      <div>
        <h4 class="font-weight-100">La calificación.</h4>
        <p class="body-font1">
          Al finalizar el análisis de cada dato proporcionado, dentro de su indicador y categoría correspondiente, se obtiene una calificación de riesgo de 0 a 100 puntos.
          <br>
          <br>
          Cada número del 40 al 100 tiene asignada una calificación de riesgo (en orden de menos a más riesgo: A+, A, A-, B+, B, B-, C+, C, C-, D+, D, D-, E+, E, E-) y estas están relacionadas a una tasa de interés. Siguiendo la regla universal de riesgo, <span class="bold">entre mayor riesgo, mayor tasa y viceversa</span>. 
          </p>
          <div class="text-align-center">
            <div v-if="isMounted" id="qualification-table" class="mb--50">
              <div class="row head mb--20">
                <div class="col-2">
                  <span>Excelente</span>
                </div>
                <div class="col-2 align-end">
                  <span>Regular</span>
                </div>
              </div>
  
              <div class="row m-auto text-align-center" style="place-content: center;">
                <!-- A -->
                <div class="col-2 chip-qualification">
                  <span class="qualification color-a">{{ qualification[0][0].qualification }}</span>
                  <span class="chip-percentage color-a">{{ (qualification[0][0].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-a">{{ qualification[0][1].qualification }}</span>
                  <span class="chip-percentage color-a">{{ (qualification[0][1].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-a">{{ qualification[0][2].qualification }}</span>
                  <span class="chip-percentage color-a">{{ (qualification[0][2].rate * 100).toFixed(2) }}%</span>
                </div>
                <!-- B -->
                <div class="col-2 chip-qualification">
                  <span class="qualification color-b">{{ qualification[0][3].qualification }}</span>
                  <span class="chip-percentage color-b">{{ (qualification[0][3].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-b">{{ qualification[0][4].qualification }}</span>
                  <span class="chip-percentage color-b">{{ (qualification[0][4].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-b">{{ qualification[0][5].qualification }}</span>
                  <span class="chip-percentage color-b">{{ (qualification[0][5].rate * 100).toFixed(2) }}%</span>
                </div>
                <!-- C -->
                <div class="col-2 chip-qualification">
                  <span class="qualification color-c">{{ qualification[0][6].qualification }}</span>
                  <span class="chip-percentage color-c">{{ (qualification[0][6].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-c">{{ qualification[0][7].qualification }}</span>
                  <span class="chip-percentage color-c">{{ (qualification[0][7].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-c">{{ qualification[0][8].qualification }}</span>
                  <span class="chip-percentage color-c">{{ (qualification[0][8].rate * 100).toFixed(2) }}%</span>
                </div>
                <!-- D -->
                <div class="col-2 chip-qualification">
                  <span class="qualification color-d">{{ qualification[0][9].qualification }}</span>
                  <span class="chip-percentage color-d">{{ (qualification[0][9].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-d">{{ qualification[0][10].qualification }}</span>
                  <span class="chip-percentage color-d">{{ (qualification[0][10].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-d">{{ qualification[0][11].qualification }}</span>
                  <span class="chip-percentage color-d">{{ (qualification[0][11].rate * 100).toFixed(2) }}%</span>
                </div>
                <!-- E -->
                <div class="col-2 chip-qualification">
                  <span class="qualification color-e">{{ qualification[0][12].qualification }}</span>
                  <span class="chip-percentage color-e">{{ (qualification[0][12].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-e">{{ qualification[0][13].qualification }}</span>
                  <span class="chip-percentage color-e">{{ (qualification[0][13].rate * 100).toFixed(2) }}%</span>
                  <br>
                  <span class="qualification color-e">{{ qualification[0][14].qualification }}</span>
                  <span class="chip-percentage color-e">{{ (qualification[0][14].rate * 100).toFixed(2) }}%</span>
                </div>
              </div>
            </div>
          </div>
        <p class="body-font1">
          Si el cliente no cuenta con una calificación mínima global, entonces la solicitud es 
          rechazada. En caso que entre en el rango aceptado, <span class="bold">RedGirasol</span> se reserva el derecho de 
          aplicar medidas compensatorias para mitigar el riesgo percibido y mejorar las condiciones 
          crediticias del solicitante de crédito. Estas medidas compensatorias implican la integración 
          de un obligado solidario, el incremento del porcentaje de enganche y/o realizar una visita con el apoyo de un estudio socioeconómico.
          <br>
          <br>
          Este modelo se calibra constantemente en base en la información recopilada y permite mayor escalabilidad para la otorgación de créditos. Un modelo de riesgo es fundamental para poder medir variables cualitativas y procesarlas a un valor cuantitativo. 
        </p>
      </div>

      <!-- Notificaci[on ] -->
      <h4 class="font-weight-100">Notificación de resultado.</h4>
      <p class="body-font1">
        Una vez aprobada la solicitud, el solicitante será notificado vía correo electrónico o WhatsApp. Para el momento en el que notificamos sobre la aprobación habrán pasado máximo 48 horas desde que se envía la solicitud formal.
        <br>
        <br>
        A partir de ese momento, el solicitante tendrá 30 días naturales para aceptar el crédito. El proyecto será publicado una vez que el solicitante haya aceptado la oferta de crédito desde su cuenta en RedGirasol.
        <br><br>
        ¿Qué te parece? En <strong>RedGirasol</strong> seguiremos trabajando constantemente para robustecer nuestro modelo y ofrecer a toda nuestra comunidad de inversionistas los proyectos más atractivos de inversión con el menor riesgo posible.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Content",
  data() {
    return {
      imgSrc: '',
      qualification: [],
      isMounted: false
    }
  },
  async mounted() {
    this.imgSrc = require('@assets/images/Score/CALIFICACION.jpg');
    this.isMounted = false;
    this.qualification = await this.getQualification();
    this.isMounted = true;
  },
  methods: {

  }
}
</script>

<style scoped>
.head {
  justify-content: space-between;
  background: rgb(128, 197, 68);
  background: linear-gradient(90deg, rgba(128, 197, 68, 1) 0%, rgba(94, 169, 100, 1) 21%, rgba(75, 140, 117, 1) 41%, rgba(51, 82, 123, 1) 62%, rgba(20, 53, 96, 1) 83%);
  height: 3rem;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  color: #FFF;
  font-weight: 700;
}

.chip-qualification span {
  border-radius: 60px;
  width: 2rem;
  height: 2rem;
  text-align: center;
  color: #FFF;
  margin-right: 10px;
  margin-bottom: 0.5rem;
}

.qualification {
  padding: 5px;
}

.chip-percentage {
  padding-left: 2rem;
  padding-right: 4rem;
  padding-top: 5px;
  padding-bottom: 5px;
}

.color-a {
  background: rgba(128, 197, 68, 1);
}

.color-b {
  background: rgba(94, 169, 100, 1);
}

.color-c {
  background: rgba(75, 140, 117, 1);
}

.color-d {
  background: rgba(51, 82, 123, 1);
}

.color-e {
  background: rgba(20, 53, 96, 1);
}

.color-f {
  background: rgba(48, 53, 118, 1);
}</style>